/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_Trainer_GymInputs */

const en_us2_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My personal trainer or gym`)
};

const pt_br2_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu personal ou academia`)
};

const es_419_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi entrenador personal o gimnasio`)
};

const pt_pt2_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu PT ou ginásio`)
};

const fr_fr2_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon coach ou ma salle`)
};

const de_de2_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Personal Trainer oder Studio`)
};

const it_it2_onboarding_how_heard_trainer_gym = /** @type {(inputs: Onboarding_How_Heard_Trainer_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio personal trainer o la mia palestra`)
};

/**
* | output |
* | --- |
* | "My personal trainer or gym" |
*
* @param {Onboarding_How_Heard_Trainer_GymInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_trainer_gym = /** @type {((inputs?: Onboarding_How_Heard_Trainer_GymInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_Trainer_GymInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_trainer_gym(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_trainer_gym(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_trainer_gym(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_trainer_gym(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_trainer_gym(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_trainer_gym(inputs)
	return en_us2_onboarding_how_heard_trainer_gym(inputs)
});
export { onboarding_how_heard_trainer_gym as "onboarding.how_heard.trainer_gym" }